var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSmallTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "0.625rem",
    height: "0.5rem",
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66666 0.333496L0.333323 0.333495L4.99999 7.66683L9.66666 0.333496Z",
    fill: "#5796B9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTriangle);
export default __webpack_public_path__ + "static/media/smallTriangle.28f361c3aee26cee934973745c1d6f7f.svg";
export { ForwardRef as ReactComponent };